import React from 'react';

import AiChatIcon from '@atlaskit/icon/core/ai-chat';
import type { NudgeRecommendationDetails } from '@atlassian/convo-ai-api';
import { type ChatAction, HandleActionType } from '@atlassian/rovo-conversation-actions/types';

import { CONVO_STARTER_ID } from '../constants';

export const buildConversationStarter = (
	recommendation: NudgeRecommendationDetails,
): ChatAction => ({
	id: CONVO_STARTER_ID,
	title: recommendation.cta.cta_label ?? '',
	icon: () => <AiChatIcon label="" />,
	type: 'convo-starter-action',
	staticPrompt: recommendation.cta.cta_label ?? '',
	starterType: 'static',
	handleType: HandleActionType.Chat,
});
